export class ProjectsRoutePaths {
  static home = '/home';

  static teamMain(teamId: string) {
    return `/${teamId}`;
  }

  static workspaceMain(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}`;
  }

  static workspaceReports(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/reports`;
  }

  static workspaceCompare(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/compare`;
  }

  static workspaceJourneyHeuristics(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/journey-heuristics`;
  }

  static workspaceWebsites(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/websites`;
  }

  static workspacePersonas(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/personas`;
  }

  static workspaceCompareWithIds(
    teamId: string,
    workspaceId: string,
    ids: string[],
    type: 'figma' | 'vibe' = 'figma'
  ) {
    const params = new URLSearchParams();

    if (ids.length) {
      params.set('ids', ids.join(','));
    }

    if (type === 'vibe') {
      params.set('tab', 'vibe');
    }

    const query = params.toString();

    return `/${teamId}/${workspaceId}/compare${query ? `?${query}` : ''}`;
  }
}
